// extracted by mini-css-extract-plugin
export var dropdown = "_qu-0";
export var imageWrapper = "_qu-3";
export var itemNameContainer = "_qu-1";
export var productImage = "_qu-2";
export var spinnerWrapper = "_qu-4";